import React, { useState, useRef, useEffect } from 'react';
// Components
import { Typography } from "@mui/material";
import { Input, Form, Select, Button, Checkbox, ToggleSwitch } from 'Components';
import { useIntl } from 'react-intl';
import moment from 'moment';

import {
    sizeDashboardPanelCreateEditModal
} from 'Redux/actions';

import './index.scss';

import ChartPie from './pie'
import ChartBar from './bar'
import { useDispatch, useSelector } from "react-redux";
import { useRealtimeTags } from 'Core/hooks';
import { backgroundColor } from './options/bgColor';
import TagsManage from 'Modules/.common/components/TagsManage';

const DASHBOARD_CHART_TAG_1_TEST_ID = 'dashboard-chart-tag1-test-id';
const DASHBOARD_CHART_TAG_2_TEST_ID = 'dashboard-chart-tag2-test-id';
const DASHBOARD_CHART_TAG_3_TEST_ID = 'dashboard-chart-tag3-test-id';

const CreateEditChart = (props) => {

    const { onSubmit, handleClose } = props;
    const dispatch = useDispatch();
    const { messages, locale } = useIntl();
    const editCreateDashboardGadgets = useRef();
    const tag1 = useRef();
    const [formData, setFormData] = useState({});
    const [showView, setShowView] = useState(true);
    const [dataChart, setDataChart] = useState({});
    const [tagPickerError, setTagPickerError] = useState({
        tag1 : false,
        tag2 : false,
    })

    const optionsView = [{
        id: 1,
        name: `${messages['dashboardPanel_edit_highest']}`
    }, {
        id: 2,
        name: `${messages['dashboardPanel_edit_lowest']}`
    }]

    const optionsFrecuency = [{
        id: 300,
        name: `5 ${messages['dashboardPanel_edit_minutes']}`
    }, {
        id: 900,
        name: `15 ${messages['dashboardPanel_edit_minutes']}`
    }, {
        id: 1800,
        name: `30 ${messages['dashboardPanel_edit_minutes']}`
    },
    {
        id: 3600,
        name: `1 ${messages['dashboardPanel_edit_hours']}`
    },
    {
        id: 7200,
        name: `2 ${messages['dashboardPanel_edit_hours']}`
    }];

    const optionsReportType = [{
        id: `IdleTime`,
        name: `${messages['dashboardPanel_edit_IdleTime']}`
    },
    {
        id: `IdleStop`,
        name: `${messages['dashboardPanel_edit_IdleStop']}`
    },
    {
        id: `DriveTime`,
        name: `${messages['dashboardPanel_edit_DriveTime']}`
    },
    {
        id: `DriverStop`,
        name: `${messages['dashboardPanel_edit_DriverStop']}`
    },
    {
        id: `Speeding`,
        name: `${messages['dashboardPanel_edit_Speeding']}`
    },
    {
        id: `Mileage`,
        name: `${messages['dashboardPanel_edit_Mileage']}`
    },
    {
        id: `EngineTime`,
        name: `${messages['dashboardPanel_edit_EngineTime']}`
    },
    {
        id: `DriverOverview`,
        name: `${messages['dashboardPanel_edit_DriverOverview']}`
    },
    {
        id: `DriverSafety`,
        name: `${messages['dashboardPanel_edit_DriverSafety']}`
    }];

    const optionsTimeMetric = [{
        id: `week`,
        name: `${messages['dashboardPanel_edit_week']}`
    }, {
        id: `month`,
        name: `${messages['dashboardPanel_edit_month']}`
    }, {
        id: `quarter`,
        name: `${messages['dashboardPanel_edit_quarter']}`
    }]

    const optionsChartType = [{
        id: `pie`,
        name: `${messages['dashboardPanel_edit_chart_pie']}`
    }, {
        id: `column`,
        name: `${messages['dashboardPanel_edit_chart_bar']}`


    }]

    const optionsGroupUnit = [{
        id: `allUnits`,
        name: `${messages['dashboardPanel_edit_allUnits']}`
    }, {
        id: `singleGroup`,
        name: `${messages['dashboardPanel_edit_singleGroup']}`
    }, {
        id: `compareGroup`,
        name: `${messages['dashboardPanel_edit_compareGroup']}`
    }]


    const {
        loadingCreateEdit,
        gadGet
    } = useSelector((state) => state.dashboardPanelRedux);

  const tags = useRealtimeTags({ trackFields: ['id', 'label', 'disabled', 'tagPath', 'tags'] });


    const dataChartChange = (timeMetric, groupUnit = null) => {
        let labels = [messages['dashboardPanel_chart_label_Mon'], messages['dashboardPanel_chart_label_Tue'], messages['dashboardPanel_chart_label_Wed'], messages['dashboardPanel_chart_label_Thu'], messages['dashboardPanel_chart_label_Fri'], messages['dashboardPanel_chart_label_Sat'], messages['dashboardPanel_chart_label_Sun']];
        let data = [300, 50, 100, 200, 500, 600, 800];
        let data2 = [150, 40, 50, 100, 200, 300, 400];
        let start = moment();
        let end = moment().locale(locale);
        switch (timeMetric) {
            case 'week':
                start = moment().startOf("week");
                break;
            case 'month':
                start = moment().subtract(30, 'days');
                labels = [];
                data = [300, 50, 100, 200, 500];
                data2 = [150, 20, 50, 100, 200];
                let nWeek = start.week();
                let nWeekLimit = nWeek + 5;
                for (let index = nWeek; index < nWeekLimit; index++) {
                    labels.push(`${messages['dashboardPanel_Week']} ${index}`)
                }
                break;
            case 'quarter':
                start = moment().subtract(2, 'month');
                labels = [];
                data = [300, 50, 100];
                data2 = [150, 20, 50];
                let monthPrevious = moment(end).subtract(1, "month");
                labels = [`${start.locale(locale).format("MMM")}`, `${monthPrevious.locale(locale).format("MMM")}`, `${end.locale(locale).format("MMM")}`];
                break;
        }

        let groupUnitUpdate = groupUnit ? groupUnit.id : formData?.groupUnit?.id;
        if (groupUnitUpdate !== "compareGroup") {
            setDataChart({
                labels,
                data: ['Example 1', 'Example 2', 'Example 3'],
                title: messages['dashboardPanel_edit_title'],
                subTitle: messages['dashboardPanel_edit_allUnits'],
                unit: messages['dashboardPanel_events'],
                datasets: [{
                    label: '',
                    data,
                    backgroundColor
                }]
            });
        } else {
            setDataChart({
                labels: labels,
                subTitle: `${messages['dashboardPanel_edit_compareGroup']} ${messages['dashboardPanel_edit_tag']} 1/${messages['dashboardPanel_edit_tag']} 2 `,
                unit: messages['dashboardPanel_events'],
                data: ['Example 1', 'Example 2', 'Example 3'],
                title: messages['dashboardPanel_edit_title'],
                datasets: [{
                    id: 1,
                    label: 'Group 1',
                    data,
                    backgroundColor
                },
                {
                    id: 2,
                    label: 'Group 2',
                    data: data2,
                    backgroundColor
                }]

            })
        }
    }

    //used to restart form when change language
    useEffect(() => {
        setFormData({})
        dataChartChange('week')
    }, [locale])

    useEffect(() => {
        if (gadGet.hasOwnProperty('name')) {
            let settings = JSON.parse(gadGet.settings);
            setFormData({
                ...formData,
                name: gadGet.name,
                reportType: optionsReportType.filter(type => type.id === settings.reportType.id)[0],
                chartType: optionsChartType.filter(chart => chart.id === settings.chartType.id)[0],
                groupUnit: optionsGroupUnit.filter(groupUnit => groupUnit.id === settings.groupUnit.id)[0],
                timeMetric: optionsTimeMetric.filter(timeMetric => timeMetric?.id === settings?.timeMetric?.id)[0],
                tag1: tags.filter(groups => groups.id == settings?.tag1),
                tag2: tags.filter(groups => groups.id == settings?.tag2),
                average: settings.average,
                show_labels: settings.show_labels,
                percentage: settings.percentage,
                unitCount: settings.chartType.id === "column" ?  settings.unitCount : 0,
                View: optionsView.filter(views => views.id === settings?.View?.id)[0],
                refreshSeconds: optionsFrecuency.filter(frecuency => frecuency.id === gadGet.refreshSeconds)[0]
            })

            dataChartChange(formData?.timeMetric?.id);


        } else {
            setFormData({ ...formData, chartType: optionsChartType[1], groupUnit: optionsGroupUnit[0], average: false,show_labels: false, percentage: false });
            dataChartChange(optionsTimeMetric[0])
        }
    }, [open, gadGet])

    useEffect(() => {
        dispatch(sizeDashboardPanelCreateEditModal('medium'));
    }, [])

    useEffect(() => {
        if (formData) {
            if (formData?.chartType?.id === 'pie' || formData?.groupUnit?.id === 'compareGroup') {
                setShowView(false);

            } else {
                setShowView(true);

            }
        }
    }, [formData])


    const validateData = () => {
        onSubmit({
            ...formData,
            tag1: formData?.tag1?.length?formData.tag1[0].id:null,
            tag2: formData?.tag2?.length?formData.tag2[0].id:null,
            refreshSeconds: formData.refreshSeconds.id
        })
    }

    const validateTags = (value,tag ) => {
        if(!value || value?.length === 0){
            setTagPickerError({...tagPickerError, [tag]:true})
            return false
        }
        return true
    }

    return (
        <div style={{ height: '100%' }}>
            <div className="column_cart_create_edit" >
                <div className="chart_edit" >
                    <Typography style={{ fontWeight: 'bold', marginLeft: 15 }} variant="subtitle1">
                        {messages['dashboardPanel_preview']}
                    </Typography>

                    {
                        formData?.chartType?.id === 'pie' &&
                        <ChartPie data={dataChart} />
                    }

                    {
                        formData?.chartType?.id !== 'pie' &&
                        <ChartBar data={dataChart} />
                    }
                </div>
            </div>
            <div className="column_cart_column_separator" >
                <Form
                    ref={editCreateDashboardGadgets}
                    onSubmit={()=>{
                        const {tag1,tag2,groupUnit} = formData
                        switch (groupUnit?.id) {
                            case "singleGroup" :
                                 return validateTags(tag1,'tag1')
                            case "compareGroup":
                                return validateTags(tag1,'tag1') && validateTags(tag2,'tag2')
                            default:
                                return true
                        }
                    }}
                    onValidSubmit={validateData}
                    style={{ height: '100%' }}>
                    <div className="form_body">
                        <div>
                            <Input
                                id="name"
                                value={formData.name || ""}
                                onChange={(value) => {
                                    setFormData({ ...formData, name: value });
                                }}
                                minLength={1}
                                maxLength={25}
                                label={messages['dashboardPanel_edit_title']}
                                placeholder={messages['dashboardPanel_edit_title']}
                                type="text"
                                required
                                requiredMessage={messages['required_field']}
                            />
                        </div>
                        <div>
                            <Select
                                id="refreshSeconds"
                                label={messages['dashboardPanel_edit_frequency']}
                                placeholder={messages['dashboardPanel_edit_frequency']}
                                loading={loadingCreateEdit}
                                options={optionsFrecuency}
                                textField="name"
                                valueField="id"
                                isSearchable={false}
                                value={formData.refreshSeconds}
                                onChange={(value) => {
                                    setFormData({ ...formData, refreshSeconds: value });
                                }}
                                isClearable
                                required
                                requiredMessage={messages['required_field']}
                            />
                        </div>
                        <div>
                            <Select
                                id="reportType"
                                label={messages['dashboardPanel_edit_report_type']}
                                placeholder={messages['dashboardPanel_edit_report_type']}
                                loading={loadingCreateEdit}
                                options={optionsReportType?.sort((a, b) => (a.name > b.name) ? 1 : -1)}
                                textField="name"
                                valueField="id"
                                isSearchable={false}
                                value={formData.reportType}
                                onChange={(value) => {
                                    setFormData({ ...formData, reportType: value });
                                    dataChartChange(formData?.timeMetric?.id);
                                }}
                                isClearable
                                required
                                requiredMessage={messages['required_field']}
                            />
                        </div>
                        <div>
                            <Select
                                id="chartType"
                                label={messages['dashboardPanel_edit_chart_type']}
                                placeholder={messages['dashboardPanel_edit_chart_type']}
                                loading={loadingCreateEdit}
                                options={optionsChartType}
                                textField="name"
                                valueField="id"
                                isSearchable={false}
                                value={formData?.chartType}
                                onChange={(value) => {
                                    let View = (value === 'pie') ? {} : formData?.View;
                                    setFormData({ ...formData, chartType: value, View });
                                    dataChartChange(formData?.timeMetric?.id);
                                }}
                                isClearable
                                required
                                requiredMessage={messages['required_field']}
                            />
                        </div>
                        <div>
                            <Select
                                id="groupUnit"
                                label={messages['dashboardPanel_edit_groups_unit']}
                                placeholder={messages['dashboardPanel_edit_groups_unit']}
                                loading={loadingCreateEdit}
                                options={optionsGroupUnit}
                                textField="name"
                                valueField="id"
                                isSearchable={false}
                                value={formData.groupUnit}
                                onChange={(value) => {
                                    setFormData({ ...formData, groupUnit: value });
                                    dataChartChange(formData?.timeMetric?.id, value);
                                }}
                                isClearable
                                required
                                requiredMessage={messages['required_field']}
                            />
                        </div>

                        {
                            formData?.groupUnit?.id === 'singleGroup' &&
                            <div style={{ marginTop: 10 }}>
                                <TagsManage
                                    data-testid={DASHBOARD_CHART_TAG_1_TEST_ID}
                                    label={`${messages[`dashboardPanel_edit_tag`]} #1`}
                                    placeholder={`${messages[`dashboardPanel_edit_tag`]} #1`}
                                    value={formData?.tag1}
                                    multiple={false}
                                    
                                    mode="selector"
                                    onlyTags={true}
                                    required
                                    onChange={(item) => {
                                        setFormData({ ...formData, tag1: item })
                                        tagPickerError.tag1 && setTagPickerError({...tagPickerError,tag1:false})
                                    }}
                                    menuStyle={{width: 315, height: 300}}   
                                    isVisiblePill={true}
                                    disableInheritance={true}
                                />
                                {tagPickerError.tag1 && <small className="text-danger">{messages['required_field']}</small>}
                            </div>
                        }

                        {
                            formData?.groupUnit?.id === 'compareGroup' &&
                            <div style={{ marginTop: 10 }}>
                                <TagsManage
                                    data-testid={DASHBOARD_CHART_TAG_2_TEST_ID}
                                    label={`${messages[`dashboardPanel_edit_tag`]} #1`}
                                    placeholder={`${messages[`dashboardPanel_edit_tag`]} #1`}
                                    value={formData?.tag1 || []}
                                    
                                    multiple={false}
                                    required
                                    mode="selector"
                                    onlyTags={true}
                                    onChange={(items) => {
                                        if(items.length > 0 && formData?.tag2?.length > 0 && items[0]?.id==formData?.tag2[0]?.id){
                                        }else{
                                            setFormData({ ...formData, tag1: items })
                                            tagPickerError.tag1 && setTagPickerError({...tagPickerError,tag1:false})
                                        }
                                    }}
                                    menuStyle={{width: 315, height: 300}}
                                    isVisiblePill={true}
                                    disableInheritance={true}
                                />
                                {tagPickerError.tag1 && <small className="text-danger">{messages['required_field']}</small>}
                            </div>
                        }

                        {
                            formData?.groupUnit?.id === 'compareGroup' &&
                            <div>
                                <TagsManage
                                    data-testid={DASHBOARD_CHART_TAG_3_TEST_ID}
                                    label={`${messages[`dashboardPanel_edit_tag`]} #2`}
                                    placeholder={`${messages[`dashboardPanel_edit_tag`]} #2`}
                                    value={formData?.tag2}
                                    multiple={false}
                                    mode="selector"
                                    onlyTags={true}
                                    
                                    required
                                    onChange={(items) => {
                                        if(items.length > 0 && formData?.tag1.length > 0 && items[0]?.id==formData?.tag1[0]?.id){
                                        }else{
                                            setFormData({ ...formData, tag2: items })
                                            tagPickerError.tag2 && setTagPickerError({...tagPickerError,tag2:false})
                                        }
                                    }}
                                    menuStyle={{width: 315, height: 300}}
                                    isVisiblePill={true}
                                    disableInheritance={true}
                                />
                                 {tagPickerError.tag2 && <small className="text-danger">{messages['required_field']}</small>}
                            </div>
                        }

                        <div>
                            <Select
                                id="timeMetric"
                                label={messages['dashboardPanel_edit_time_metric']}
                                placeholder={messages['dashboardPanel_edit_time_metric']}
                                loading={loadingCreateEdit}
                                options={optionsTimeMetric}
                                textField="name"
                                valueField="id"
                                isSearchable={false}
                                value={formData.timeMetric}
                                onChange={(value) => {
                                    setFormData({ ...formData, timeMetric: value });
                                    dataChartChange(value.id);
                                }}
                                isClearable
                                required
                                requiredMessage={messages['required_field']}
                            />
                        </div>
                        {
                            showView &&
                            <div>
                                <Select
                                    id="view"
                                    label={messages['dashboardPanel_edit_view']}
                                    placeholder={messages['dashboardPanel_edit_view']}
                                    loading={loadingCreateEdit}
                                    options={optionsView}
                                    textField="name"
                                    valueField="id"
                                    isSearchable={false}
                                    value={formData.View}
                                    onChange={(value) => {
                                        setFormData({ ...formData, View: value });
                                    }}
                                    isClearable
                                />
                            </div>
                        }

                        {
                            formData?.View?.id && formData?.chartType?.id !== 'pie' 
                            && formData?.groupUnit?.id !== 'compareGroup' 
                            &&
                            <div>
                                <Input
                                    id="unitCount"
                                    type="number"
                                    value={formData.unitCount || ""}
                                    label={messages['dashboardPanel_edit_unit_count']}
                                    loading={loadingCreateEdit}
                                    placeholder={messages['dashboardPanel_edit_unit_count']}
                                    min={1}
                                    minMessage={`${messages['min']}: 1`}
                                    max={21}
                                    maxMessage={`${messages['max']}: 20`}
                                    onChange={(value) => {
                                        if(value<=20) setFormData({ ...formData, unitCount: value });
                                    }}
                                    required
                                    requiredMessage={messages['required_field']}
                                />
                            </div>
                        }

                        {
                            formData?.chartType?.id !== 'pie' &&

                            <div style={{ marginTop: 15 }} >
                                <ToggleSwitch
                                    id={`average`}
                                    blueToggle
                                    mediuml
                                    optionLabels={[messages['show'], messages['show']]}
                                    checked={formData?.average}
                                    onChange={(checked) => {
                                        setFormData({ ...formData, average: checked });
                                    }} />
                                <label>
                                    {messages['dashboardPanel_edit_average']}
                                </label>
                            </div>
                        }

                        <div style={{ marginTop: 15 }}>
                            <ToggleSwitch
                                id={`percentage`}
                                blueToggle
                                mediuml
                                optionLabels={[messages['show'], messages['show']]}
                                checked={formData?.percentage}
                                onChange={(checked) => {
                                    setFormData({ ...formData, percentage: checked });
                                }} />
                            <label>
                                {messages['dashboardPanel_edit_percentage']}
                            </label>
                        </div>

                        {
                            formData?.chartType?.id === 'pie' &&

                            <div style={{ marginTop: 15 }} >
                                <ToggleSwitch
                                    id={`show_labels`}
                                    blueToggle
                                    mediuml
                                    optionLabels={[messages['show'], messages['show']]}
                                    checked={formData?.show_labels}
                                    onChange={(checked) => {
                                        setFormData({ ...formData, show_labels: checked });
                                    }} />
                                <label>
                                    {messages['dashboardPanel_edit_show_labels']}
                                </label>
                            </div>
                        }
                    </div>
                </Form>
                <div style={{
                    bottom: 0,
                    position: 'fixed',
                    padding: 15,
                    backgroundColor: '#fff',
                    width: '38.2%',
                }}>
                    <Button
                        disabled={loadingCreateEdit}
                        className="btn-cancel"
                        onClick={(e) => {
                            if (e) e.preventDefault();
                            dispatch(sizeDashboardPanelCreateEditModal('small'));
                            handleClose();
                        }}
                    >
                        {messages['cancel']}
                    </Button>
                    <Button
                        disabled={loadingCreateEdit}
                        onClick={(e) => {
                            if (e) e.preventDefault();
                            editCreateDashboardGadgets.current.submit();
                        }}
                        className="btn-blue"
                    >
                        {messages['save']}
                    </Button>
                </div>
            </div>
        </div>

    );
}

export default CreateEditChart;
